var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wrong"},[_c('div',{staticClass:"wrap"},[_c('img',{staticClass:"wrong__image",attrs:{"src":require("@/assets/images/404.png")}}),_c('router-link',{staticClass:"button",attrs:{"to":{name: 'events'}}},[_vm._v("Вернуться домой")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }